<template>
    <div class="foot">
        <div class="item">
            <div class="itemSc">
                <span class="star" :class="{'star2': isStar}" @click="onPopup(6)"></span>
                <div class="name">收藏</div>
            </div>
            <div class="itemSc">
                <span class="cart" @click="onPopup(7)"><sup class="c1" v-show="wCartNum" v-text="wCartNum"></sup></span>
                <div class="name">购物车</div>
            </div>
        </div>
        <div class="item2">
            <div class="btn">
                <div class="btn1 btnBg" @click="onPopup(3)">加入购物车</div>
                <div class="btn1 btnRed" @click="onPopup(3)">立即购买</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isStar: {
            type: Boolean,
            default: false
        },
        wCartNum: {
            type: null,
            default: 0
        }
    },
    methods: {
        onPopup (type) {
            this.$emit('onPopup', type)
        }
    }
}
</script>

<style lang="scss" scoped>
    .foot {
        background: #ffffff;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 32px 32px 32px 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 9;
        .item {
            display: flex;
            text-align: center;
            font-size: 20px;
            .itemSc {
                position: relative;
                width: 80px;
                text-align: center;
                margin-right: 20px;
                top: -8px;
                .name {
                    color: #999999;
                    transform: scale(0.75);
                    position: absolute;
                    width: 100%;
                    text-align: center;
                    top: 48px;
                    left: 0;
                }
            }
            span {
                width: 48px;
                height: 48px;
                display: inline-block;
                position: relative;
                .c1 {
                    position: absolute;
                    font-size: 20px;
                    top: -20px;
                    right: -20px;
                    width: 36px;
                    height: 36px;
                    line-height: 36px;
                    letter-spacing: -2px;
                    background: #ff7a45;
                    color: #fff;
                    text-align: center;
                    border-radius: 36px;
                }
                .c2 {
                    width: auto;
                }
                &.cart {
                    background: url('../../../../assets/img/b2b/cart.png') no-repeat;
                    background-size: 100% 100%;
                }
                &.star {
                    background: url('../../../../assets/img/b2b/star.png') no-repeat;
                    background-size: 100% 100%;
                }
                &.star2 {
                    background: url('../../../../assets/img/b2b/icon_star_pre@2x.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
        .item2 {
            // flex: 1;
            .btn {
                display: flex;
                justify-content: space-between;
                .btn1 {
                    width: 208px;
                    height: 64px;
                    line-height: 64px;
                    // border: 3px solid #FF7A45;
                    border-radius: 64px;
                    text-align: center;
                    margin-left: 20px;
                    color: #ff7a45;
                    &.btnBg {
                        background: #ff7a45;
                        color: #ffffff;
                    }
                    &.btnRed {
                        background: #ff4d4f;
                        color: #ffffff;
                    }
                }
                .oos {
                    width: 436px;
                    color: #c7c7c7;
                    border: 2px solid #eaeaea;
                    background: #eaeaea;
                }
            }
            .btnWh {
                width: 440px;
                height: 64px;
                line-height: 64px;
                font-size: 28px;
                text-align: center;
                background: #ABABAB;
                border-radius: 64px;
                color: #ffffff;
            }
        }
    }
</style>